import { useTranslation } from 'react-i18next';
import { GovSkeleton } from '@gov-design-system-ce/react';
import { LocalizeNameSpaceTypes } from '@gov-nx/core/service';
import { LayoutGap } from '@gov-nx/ui/web';

export const DataboxAdditionalSettingsSkeleton = () => {
	const { t } = useTranslation(LocalizeNameSpaceTypes.Global);

	return (
		<LayoutGap gap="m">
			<div>
				<div className="w-full">
					<GovSkeleton
						height="24px"
						width="40px"
						className="mr-4!"
						aria-label={t('loading.wcag.processing')}
					/>
					<GovSkeleton
						height="24px"
						width="240px"
						aria-label={t('loading.wcag.processing')}
					/>
				</div>
				<GovSkeleton
					height="14px"
					width="90%"
					aria-label={t('loading.wcag.processing')}
				/>
				<GovSkeleton
					height="14px"
					width="70%"
					aria-label={t('loading.wcag.processing')}
				/>
			</div>
			<GovSkeleton
				height="38px"
				width="230px"
				className="py-2"
				aria-label={t('loading.wcag.processing')}
			/>
		</LayoutGap>
	);
};
